import { render, staticRenderFns } from "./SociosModificarDatos.vue?vue&type=template&id=2fc98006&"
import script from "./SociosModificarDatos.vue?vue&type=script&lang=js&"
export * from "./SociosModificarDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports